// Adjust the import path according to your project structure
// //
import HeadingContainer from "@podcastsoundboard/ps-lib/components/HeadingContainer"
// Assuming RootState is the type of your entire Redux state
import { useAppDispatch, useAppSelector } from "../../../../redux"
import { setDuckPercentage } from "../../../../redux/duckPercentage"
import { setIsDucked } from "../../../../redux/isDucked"
import { setMasterVolume } from "../../../../redux/masterVolume"
import {
  Box,
  Button,
  Container,
  IconButton,
  Link,
  Paper,
  Slider,
  Stack,
  Tooltip,
  Typography,
} from "@podcastsoundboard/ps-lib/ui"
import KeyboardDoubleArrowDownIcon from "@podcastsoundboard/ps-lib/ui/icons/KeyboardDoubleArrowDown"
import VolumeDown from "@podcastsoundboard/ps-lib/ui/icons/VolumeDown"
import VolumeUp from "@podcastsoundboard/ps-lib/ui/icons/VolumeUp"

export default function Settings(): JSX.Element {
  const dispatch = useAppDispatch()
  const duckPercentage = useAppSelector((state) => state.duckPercentage)
  const isDucked = useAppSelector((state) => state.isDucked)
  const masterVolume = useAppSelector((state) => state.masterVolume)

  return (
    <>
      <HeadingContainer className="mb-8">
        <Typography component="h1" variant="h6" color="textPrimary" noWrap>
          Global Settings
        </Typography>
      </HeadingContainer>

      <Container maxWidth="md" className="mb-4 pb-4">
        <Paper className="p-4 pb-2 mb-4" elevation={4}>
          <Typography color="textPrimary" variant="h5" className="pb-4">
            Master Volume
          </Typography>

          <Box style={{ width: "100%" }}>
            <Stack
              spacing={2}
              direction="row"
              className="mb-2"
              alignItems="center"
            >
              <VolumeDown />
              <Slider
                min={0}
                max={1}
                step={0.01}
                name="Volume"
                value={masterVolume}
                onChange={(_e, newValue: number | number[]) =>
                  dispatch(setMasterVolume(newValue as number))
                }
                valueLabelDisplay="auto"
              />
              <VolumeUp />
            </Stack>
          </Box>

          <Typography variant="body1">
            Master volume is {Math.round(masterVolume * 100)}%.
          </Typography>
        </Paper>

        <Paper className="p-4 mb-4" elevation={4}>
          <Typography color="textPrimary" variant="h5" className="pb-4">
            Duck Amount
          </Typography>

          <Box style={{ width: "100%" }}>
            <Stack
              spacing={2}
              direction="row"
              className="mb-2"
              alignItems="center"
            >
              <Tooltip
                title={isDucked ? "Duck enabled" : "Amount to duck audio"}
              >
                <IconButton
                  onClick={() => dispatch(setIsDucked(!isDucked))}
                  className="-ml-2"
                >
                  <KeyboardDoubleArrowDownIcon
                    className={isDucked ? "text-primary" : undefined}
                  />
                </IconButton>
              </Tooltip>
              <Slider
                min={0}
                max={100}
                step={1}
                name="Duck percentage"
                value={duckPercentage}
                onChange={(_e, newValue: number | number[]) =>
                  dispatch(setDuckPercentage(newValue as number))
                }
                valueLabelDisplay="auto"
              />
              <VolumeUp style={{ opacity: 0 }} />
            </Stack>
          </Box>

          <Typography variant="body1">
            Audio will be reduced {Math.round(duckPercentage)}% when ducked.
          </Typography>
        </Paper>
        <Paper className="p-4" elevation={4}>
          <Typography color="textPrimary" variant="h5" className="pb-4">
            Freesound Account
          </Typography>

          <Box style={{ width: "100%" }}>
            <Typography className="mb-4">
              To import sounds from Freesound, you must link your Freesound
              account. Create a freesound account at{" "}
              <Link href="https://freesound.org" target="_blank">
                freesound.org
              </Link>
              .
            </Typography>

            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                window.open(
                  `/api/v1/auth/freesound?state=${encodeURIComponent(
                    window.location.pathname,
                  )}`,
                  "_blank",
                )
              }}
            >
              Link Freesound account
            </Button>
          </Box>
        </Paper>
      </Container>
    </>
  )
}
